
export default function Donate() {
  return (
    <section className="w-full">
      <div className="grid grid-cols-2">
        {/* Left Side - Image */}
        <div className="relative bg-[#F5E6D3] h-[700px]">
          <div className="absolute top-8 left-8">
            <span className="text-xs uppercase tracking-wider text-[#616161] font-semibold">SUPPORT</span>
          </div>
          <img 
            src="https://public.readdy.ai/ai/img_res/c520be4efdde7615baadbbe9d04f555b.jpg" 
            alt="Longhorn with cross" 
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-12 left-12">
            <div className="text-black" style={{ fontFamily: 'Playfair Display, serif' }}>
              <div className="text-6xl font-normal mb-2">Make</div>
              <div className="text-7xl font-bold mb-2">A Difference</div>
              <div className="text-6xl font-normal">Today</div>
            </div>
          </div>
        </div>

        {/* Right Side - Content */}
        <div className="bg-white flex items-center justify-center px-16 py-20">
          <div className="max-w-xl text-center">
            <h2 className="text-5xl font-bold text-[#3E2723] mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Your Gift Supports<br />Our Sacred Mission
            </h2>
            <div className="space-y-6 text-lg text-[#616161] leading-relaxed mb-10">
              <p>
                Every donation helps us continue our ministry of faithful stewardship and community service. Your support enables us to care for our longhorn cattle with excellence, provide food assistance to families in need, and offer educational programs that inspire the next generation.
              </p>
              <p>
                Whether you contribute to cattle care, community outreach programs, or faith education initiatives, your generosity makes a lasting impact. Together, we can expand our reach and touch more lives with God's love.
              </p>
              <p>
                Join us in this sacred work. Your partnership helps us fulfill our calling to serve both God's creation and His people with devotion and purpose.
              </p>
            </div>
            <button className="px-10 py-4 bg-[#3E2723] text-white rounded-full font-semibold text-lg hover:bg-[#5D4037] transition-all whitespace-nowrap">
              Donate Now →
            </button>
            <p className="mt-6 text-sm text-[#616161]">
              Cows4Christ is a 501(c)(3) nonprofit organization. All donations are tax-deductible.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
